import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles, Grid } from '@material-ui/core';
import { FHEContainerForm, FHEItemText, FHEDivider, FHEMiniFormEditButton, FHETextField } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { updateProductModule, updateProductModuleLabel } from '../../../../../data/Products/actions';

class Airzone extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        planningMode: PropTypes.string,
        moduleType: PropTypes.string,
        lineType: PropTypes.string,
        code: PropTypes.string,
        fheCenter_mac: PropTypes.string,
        planningSynched: PropTypes.number,
        value: PropTypes.string,
        consignTemp: PropTypes.string,
        label: PropTypes.string,
        planningType: PropTypes.string,
        favorite: PropTypes.number,
        updateProductModuleLabel: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        type: PropTypes.string
    };

    static defaultProps = {
        planningMode: null,
        moduleType: null,
        code: null,
        planningSynched: null,
        value: null,
        fheCenter_mac: null,
        consignTemp: null,
        label: null,
        planningType: null,
        favorite: null,
        type: null,
        lineType: null
    };

    constructor(props) {
        super(props);
        const { label } = props;

        this.state = {
            formDisabled: true,
            textInput_error: {},
            sendLoading: false,
            form: {
                label: label
            }
        };
    }

    static getDerivedStateFromProps(props, state) {
        const { formDisabled } = state;
        const { label } = props;
        if (formDisabled) {
            let form = {
                label: state.form.label
            };
            if (props.label !== state.form.label) {
                form.label = label;
            }
            return {
                form: form
            };
        } else {
            return null;
        }
    }

    handleClick = () => {
        this.setState({
            formDisabled: false
        });
    };

    handleEdit = () => {
        const { formDisabled } = this.state;
        this.setState({
            formDisabled: !formDisabled
        });
    };

    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>
                );
            });
        });

        this.setState({
            textInput_error: res
        });

        return Toastr.error(message);
    };

    handleChangeWithVerification = event => {
        const { form, textInput_error } = this.state;
        let targetValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        const fieldLengthRules = {
            label: 255
        };

        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        let maxLength = fieldLengthRules[event.target.name];
        if (maxLength && targetValue.length > maxLength) targetValue = form[event.target.name];
        if (targetValue === '') targetValue = null;

        this.setState({
            form: { ...form, [event.target.name]: targetValue },
            textInput_error: newTextInput_error
        });
    };

    handleChange = event => {
        const { form } = this.state;

        this.setState({
            form: { ...form, [event.target.name]: event.target.value }
        });
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    loadInputs = () => {
        const { label } = this.props;
        this.setState({
            sendLoading: false,
            formDisabled: true,
            textInput_error: {},
            form: {
                label: label
            }
        });
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v }))
        );
    };

    formatForm = () => {
        const { form } = this.state;
        let newForm = form;
        Object.keys(newForm).forEach(key => {
            if (newForm[key] === '') {
                newForm[key] = null;
            }
        });
        this.setState({
            form: newForm
        });
    };

    confirmEdit = () => {
        const { form } = this.state;
        const { updateProductModuleLabel, match, type, code, fheCenter_mac, history } = this.props;

        this.formatForm();

        if (this.validateForm(form)) {
            this.setState({
                sendLoading: true,
                formDisabled: true
            });
            return updateProductModuleLabel(fheCenter_mac, match.params.productIdentifier, match.params.productType, type, code, form.label)
                .then(() => {
                    Toastr.success(Translator.translate(`generic.products.actions.editProductModuleSuccess`));
                    this.loadInputs();
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false,
                        formDisabled: false
                    });
                    Toastr.error(
                        Translator.translateWithFallback(`socket.error.${error.message ? error.message : error}`, 'socket.error.defaultError'),
                        Translator.translate(`generic.products.actions.editProductModuleError`)
                    );
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(error.validation.errors, Translator.translate(`generic.products.actions.editProductModuleError`));
                    }
                });
        }
    };

    validateForm = form => {
        const errors = {};

        if (this.isEmpty(form.label)) {
            errors['label'] = Translator.translate('general.fields.error.any.empty');
        }

        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    };

    render() {
        const {
            theme,
            planningMode,
            moduleType,
            code,
            planningSynched,
            value,
            consignTemp,
            planningType,
            favorite,
            profile,
            type,
            history,
            lineType
        } = this.props;
        const { formDisabled, textInput_error, form, sendLoading } = this.state;
        const userRightUpdate =
            profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`productModules_${type}_${lineType}_update`);
        return (
            <FHEContainerForm withoutPadding>
                <Grid container spacing={3}>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEMiniFormEditButton
                            handleEdit={this.handleEdit}
                            confirmEdit={this.confirmEdit}
                            sendLoading={sendLoading}
                            formDisabled={formDisabled}
                            hasRightToEdit={userRightUpdate}
                        >
                            <FHETextField
                                disabled={formDisabled || !userRightUpdate}
                                id="label"
                                value={!form.label || form.label === null ? '' : form.label}
                                error={textInput_error.label}
                                helperText={textInput_error.label ? textInput_error.label : null}
                                label={Translator.translate('general.table.column.label')}
                                name="label"
                                onChange={this.handleChangeWithVerification}
                            />
                        </FHEMiniFormEditButton>
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.moduleType')}
                            itemContent={Translator.translate(`general.productModules.${moduleType}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.code')} itemContent={code} />
                    </Grid>
                </Grid>
                <FHEDivider color={theme.palette.colors.grey100} />
                <Grid container spacing={3}>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.planningMode')}
                            itemContent={Translator.translate(`general.productModules.${planningMode}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.planningType')}
                            itemContent={Translator.translate(`general.productModules.${planningType}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.planningSynched')}
                            itemContent={Translator.translate(`general.productModules.${planningSynched}`)}
                        />
                    </Grid>
                </Grid>
                <FHEDivider color={theme.palette.colors.grey100} />
                <Grid container spacing={3}>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.value')} itemContent={value} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.consignTemp')} itemContent={consignTemp} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.favorite')}
                            itemContent={Translator.translate(`general.productModules.${favorite}`)}
                        />
                    </Grid>
                </Grid>
            </FHEContainerForm>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const productKey = props.productKey;
    const productModulekey = props.productModulekey;
    const product = state.environments[history.environment].data.Products.getIn(['list', productKey], new Map());
    let productModule;
    if (state.environments[history.environment].data.Products.getIn(['list', productKey, 'productModules'])) {
        productModule = state.environments[history.environment].data.Products.getIn(
            ['list', productKey, 'productModules', productModulekey],
            new Map()
        );
    }
    if (productModule === undefined) {
        productModule = new Map();
    }
    let fheCenter_mac = null;
    state.environments[history.environment].data.Boxes.get('list').map((box, macAddress) => {
        if (box.get('homeId') === productModule.get('homeId')) fheCenter_mac = macAddress;
    });
    return {
        profile: state.data.user,
        type: product.get('type'),
        lineType: productModule.get('productType'),
        planningMode: productModule.get('planningMode'),
        moduleType: productModule.get('moduleType'),
        code: productModule.get('code'),
        planningSynched: productModule.get('planningSynched'),
        value: productModule.get('value'),
        consignTemp: productModule.get('consignTemp'),
        label: productModule.get('label'),
        planningType: productModule.get('planningType'),
        favorite: productModule.get('favorite'),
        fheCenter_mac
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    }
});

export default withRouter(
    renderEnvComponent(
        'scenes/Products/components/ProductModule/Airzone/index',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, {
                        updateProductModule,
                        updateProductModuleLabel
                    }),
                    dispatch
                )
        )(withStyles(styles, { withTheme: true })(Airzone))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/ProductModule/Airzone/index.js